"use client";
import * as f from "react";
import { c as Oe } from "./floating-ui.utils.dom-DmuU7Umk.mjs";
import { u as H } from "./useLatestRef-BZ_hd_SE.mjs";
import { u as _ } from "./useEventCallback-CjuAhyNz.mjs";
import { u as z } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { a as Se, u as De } from "./FloatingTree-vWe5pGqE.mjs";
import { e as Te } from "./useScrollLock-COQT0_go.mjs";
import { h as Ae, i as Ne, e as Ce, f as Ve, c as ze, a as ae, b as Z, d as ee, A as Pe } from "./element-DE7VsBMX.mjs";
import { h as ve, g as me, a as Le, c as We, i as he, b as Ge, d as He, e as _e, f as se } from "./composite-DRO3S53u.mjs";
import { s as A, a as qe, b as Be } from "./event-CXjJudzK.mjs";
import { u as Ue } from "./useTimeout-BRUciAq6.mjs";
const $e = "Escape";
function le(o, c, n) {
  switch (o) {
    case "vertical":
      return c;
    case "horizontal":
      return n;
    default:
      return c || n;
  }
}
function ue(o, c) {
  return le(c, o === Pe || o === ae, o === Z || o === ee);
}
function pe(o, c, n) {
  return le(c, o === ae, n ? o === Z : o === ee) || o === "Enter" || o === " " || o === "";
}
function je(o, c, n) {
  return le(c, n ? o === Z : o === ee, o === ae);
}
function Je(o, c, n, d) {
  const u = n ? o === ee : o === Z, k = o === Pe;
  return c === "both" || c === "horizontal" && d && d > 1 ? o === $e : le(c, u, k);
}
function ct(o, c) {
  const {
    open: n,
    onOpenChange: d,
    elements: u,
    floatingId: k
  } = o, {
    listRef: i,
    activeIndex: F,
    onNavigate: q = () => {
    },
    enabled: M = !0,
    selectedIndex: b = null,
    allowEscape: N = !1,
    loop: O = !1,
    nested: C = !1,
    rtl: g = !1,
    virtual: m = !1,
    focusItemOnOpen: E = "auto",
    focusItemOnHover: $ = !0,
    openOnArrowKeyDown: B = !0,
    disabledIndices: w = void 0,
    orientation: R = "vertical",
    parentOrientation: K,
    cols: v = 1,
    scrollItemIntoView: te = !0,
    virtualItemRef: j,
    itemSizes: l,
    dense: ne = !1
  } = c;
  process.env.NODE_ENV !== "production" && (N && (O || console.warn("`useListNavigation` looping must be enabled to allow escaping."), m || console.warn("`useListNavigation` must be virtual to allow escaping.")), R === "vertical" && v > 1 && console.warn("In grid list navigation mode (`cols` > 1), the `orientation` should", 'be either "horizontal" or "both".'));
  const S = Ae(u.floating), re = H(S), W = Se(), I = De();
  z(() => {
    o.dataRef.current.orientation = R;
  }, [o, R]);
  const D = Ne(u.domReference), x = f.useRef(E), r = f.useRef(b ?? -1), L = f.useRef(null), P = f.useRef(!0), y = _(() => {
    q(r.current === -1 ? null : r.current);
  }), Re = f.useRef(y), J = f.useRef(!!u.floating), ye = f.useRef(n), G = f.useRef(!1), oe = f.useRef(!1), Q = H(w), fe = H(n), ke = H(te), Ie = H(b), [we, Fe] = f.useState(), de = _(() => {
    function e(a) {
      var p;
      m ? ((p = a.id) != null && p.endsWith("-fui-option") && (a.id = `${k}-${Math.random().toString(16).slice(2, 10)}`), Fe(a.id), I == null || I.events.emit("virtualfocus", a), j && (j.current = a)) : Te(a, {
        sync: G.current,
        preventScroll: !0
      });
    }
    const s = i.current[r.current], t = oe.current;
    s && e(s), (G.current ? (a) => a() : requestAnimationFrame)(() => {
      var U;
      const a = i.current[r.current] || s;
      if (!a)
        return;
      s || e(a);
      const p = ke.current;
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      p && ge && (t || !P.current) && ((U = a.scrollIntoView) == null || U.call(a, typeof p == "boolean" ? {
        block: "nearest",
        inline: "nearest"
      } : p));
    });
  });
  z(() => {
    M && (n && u.floating ? x.current && b != null && (oe.current = !0, r.current = b, y()) : J.current && (r.current = -1, Re.current()));
  }, [M, n, u.floating, b, y]), z(() => {
    if (M && n && u.floating)
      if (F == null) {
        if (G.current = !1, Ie.current != null)
          return;
        if (J.current && (r.current = -1, de()), (!ye.current || !J.current) && x.current && (L.current != null || x.current === !0 && L.current == null)) {
          let e = 0;
          const s = () => {
            i.current[0] == null ? (e < 2 && (e ? requestAnimationFrame : queueMicrotask)(s), e += 1) : (r.current = L.current == null || pe(L.current, R, g) || C ? me(i, Q.current) : Le(i, Q.current), L.current = null, y());
          };
          s();
        }
      } else ve(i, F) || (r.current = F, de(), oe.current = !1);
  }, [M, n, u.floating, F, Ie, C, i, R, g, y, de, Q]), z(() => {
    var a, p;
    if (!M || u.floating || !I || m || !J.current)
      return;
    const e = I.nodesRef.current, s = (p = (a = e.find((T) => T.id === W)) == null ? void 0 : a.context) == null ? void 0 : p.elements.floating, t = Ce(Ve(u.floating)), h = e.some((T) => T.context && ze(T.context.elements.floating, t));
    s && !h && P.current && s.focus({
      preventScroll: !0
    });
  }, [M, u.floating, I, W, m]), z(() => {
    Re.current = y, ye.current = n, J.current = !!u.floating;
  }), z(() => {
    n || (L.current = null, x.current = E);
  }, [n, E]);
  const xe = F != null, ge = f.useMemo(() => {
    function e(t) {
      if (!fe.current)
        return;
      const h = i.current.indexOf(t);
      h !== -1 && r.current !== h && (r.current = h, y());
    }
    return {
      onFocus({
        currentTarget: t
      }) {
        G.current = !0, e(t);
      },
      onClick: ({
        currentTarget: t
      }) => t.focus({
        preventScroll: !0
      }),
      // Safari
      onMouseMove({
        currentTarget: t
      }) {
        G.current = !0, oe.current = !1, $ && e(t);
      },
      onPointerLeave({
        pointerType: t
      }) {
        var h;
        !P.current || t === "touch" || (G.current = !0, $ && (r.current = -1, y(), m || (h = re.current) == null || h.focus({
          preventScroll: !0
        })));
      }
    };
  }, [fe, re, $, i, y, m]), ie = f.useCallback(() => {
    var e, s, t;
    return K ?? ((t = (s = (e = I == null ? void 0 : I.nodesRef.current.find((h) => h.id === W)) == null ? void 0 : e.context) == null ? void 0 : s.dataRef) == null ? void 0 : t.current.orientation);
  }, [W, I, K]), X = _((e) => {
    if (P.current = !1, G.current = !0, e.which === 229 || !fe.current && e.currentTarget === re.current)
      return;
    if (C && Je(e.key, R, g, v)) {
      ue(e.key, ie()) || A(e), d(!1, e.nativeEvent, "list-navigation"), Oe(u.domReference) && (m ? I == null || I.events.emit("virtualfocus", u.domReference) : u.domReference.focus());
      return;
    }
    const s = r.current, t = me(i, w), h = Le(i, w);
    if (D || (e.key === "Home" && (A(e), r.current = t, y()), e.key === "End" && (A(e), r.current = h, y())), v > 1) {
      const a = l || Array.from({
        length: i.current.length
      }, () => ({
        width: 1,
        height: 1
      })), p = We(a, v, ne), T = p.findIndex((V) => V != null && !he(i, V, w)), U = p.reduce((V, Y, Ke) => Y != null && !he(i, Y, w) ? Ke : V, -1), Ee = p[Ge({
        current: p.map((V) => V != null ? i.current[V] : null)
      }, {
        event: e,
        orientation: R,
        loop: O,
        rtl: g,
        cols: v,
        // treat undefined (empty grid spaces) as disabled indices so we
        // don't end up in them
        disabledIndices: _e([...(typeof w != "function" ? w : null) || i.current.map((V, Y) => he(i, Y, w) ? Y : void 0), void 0], p),
        minIndex: T,
        maxIndex: U,
        prevIndex: He(
          r.current > h ? t : r.current,
          a,
          p,
          v,
          // use a corner matching the edge closest to the direction
          // we're moving in so we don't end up in the same item. Prefer
          // top/left over bottom/right.
          // eslint-disable-next-line no-nested-ternary
          e.key === ae ? "bl" : e.key === (g ? Z : ee) ? "tr" : "tl"
        ),
        stopEvent: !0
      })];
      if (Ee != null && (r.current = Ee, y()), R === "both")
        return;
    }
    if (ue(e.key, R)) {
      if (A(e), n && !m && Ce(e.currentTarget.ownerDocument) === e.currentTarget) {
        r.current = pe(e.key, R, g) ? t : h, y();
        return;
      }
      pe(e.key, R, g) ? O ? r.current = // eslint-disable-next-line no-nested-ternary
      s >= h ? N && s !== i.current.length ? -1 : t : se(i, {
        startingIndex: s,
        disabledIndices: w
      }) : r.current = Math.min(h, se(i, {
        startingIndex: s,
        disabledIndices: w
      })) : O ? r.current = // eslint-disable-next-line no-nested-ternary
      s <= t ? N && s !== -1 ? i.current.length : h : se(i, {
        startingIndex: s,
        decrement: !0,
        disabledIndices: w
      }) : r.current = Math.max(t, se(i, {
        startingIndex: s,
        decrement: !0,
        disabledIndices: w
      })), ve(i, r.current) && (r.current = -1), y();
    }
  }), ce = f.useMemo(() => m && n && xe && {
    "aria-activedescendant": we
  }, [m, n, xe, we]), Me = f.useMemo(() => ({
    "aria-orientation": R === "both" ? void 0 : R,
    ...D ? {} : ce,
    onKeyDown(e) {
      if (e.key === "Tab" && e.shiftKey && n && !m) {
        A(e), d(!1, e.nativeEvent, "list-navigation"), Oe(u.domReference) && u.domReference.focus();
        return;
      }
      X(e);
    },
    onPointerMove() {
      P.current = !0;
    }
  }), [ce, X, R, D, d, n, m, u.domReference]), be = f.useMemo(() => {
    function e(t) {
      E === "auto" && qe(t.nativeEvent) && (x.current = !0);
    }
    function s(t) {
      x.current = E, E === "auto" && Be(t.nativeEvent) && (x.current = !0);
    }
    return {
      ...ce,
      onKeyDown(t) {
        P.current = !1;
        const h = t.key.startsWith("Arrow"), a = je(t.key, ie(), g), p = ue(t.key, R), T = (C ? a : p) || t.key === "Enter" || t.key.trim() === "";
        if (m && n)
          return X(t);
        if (!(!n && !B && h)) {
          if (T) {
            const U = ue(t.key, ie());
            L.current = C && U ? null : t.key;
          }
          if (C) {
            a && (A(t), n ? (r.current = me(i, Q.current), y()) : d(!0, t.nativeEvent, "list-navigation"));
            return;
          }
          p && (b != null && (r.current = b), A(t), !n && B ? d(!0, t.nativeEvent, "list-navigation") : X(t), n && y());
        }
      },
      onFocus() {
        n && !m && (r.current = -1, y());
      },
      onPointerDown: s,
      onPointerEnter: s,
      onMouseDown: e,
      onClick: e
    };
  }, [ce, X, Q, E, i, C, y, d, n, B, R, ie, g, b, m]);
  return f.useMemo(() => M ? {
    reference: be,
    floating: Me,
    item: ge
  } : {}, [M, be, Me, ge]);
}
function st(o, c) {
  const {
    open: n,
    dataRef: d
  } = o, {
    listRef: u,
    activeIndex: k,
    onMatch: i,
    onTypingChange: F,
    enabled: q = !0,
    findMatch: M = null,
    resetMs: b = 750,
    ignoreKeys: N = [],
    selectedIndex: O = null
  } = c, C = Ue(), g = f.useRef(""), m = f.useRef(O ?? k ?? -1), E = f.useRef(null), $ = _(i), B = _(F), w = H(M), R = H(N);
  z(() => {
    n && (C.clear(), E.current = null, g.current = "");
  }, [n, C]), z(() => {
    n && g.current === "" && (m.current = O ?? k ?? -1);
  }, [n, O, k]);
  const K = _((l) => {
    l ? d.current.typing || (d.current.typing = l, B(l)) : d.current.typing && (d.current.typing = l, B(l));
  }), v = _((l) => {
    function ne(D, x, r) {
      const L = w.current ? w.current(x, r) : x.find((P) => (P == null ? void 0 : P.toLocaleLowerCase().indexOf(r.toLocaleLowerCase())) === 0);
      return L ? D.indexOf(L) : -1;
    }
    const S = u.current;
    if (g.current.length > 0 && g.current[0] !== " " && (ne(S, S, g.current) === -1 ? K(!1) : l.key === " " && A(l)), S == null || R.current.includes(l.key) || // Character key.
    l.key.length !== 1 || // Modifier key.
    l.ctrlKey || l.metaKey || l.altKey)
      return;
    n && l.key !== " " && (A(l), K(!0)), S.every((D) => {
      var x, r;
      return D ? ((x = D[0]) == null ? void 0 : x.toLocaleLowerCase()) !== ((r = D[1]) == null ? void 0 : r.toLocaleLowerCase()) : !0;
    }) && g.current === l.key && (g.current = "", m.current = E.current), g.current += l.key, C.start(b, () => {
      g.current = "", m.current = E.current, K(!1);
    });
    const W = m.current, I = ne(S, [...S.slice((W || 0) + 1), ...S.slice(0, (W || 0) + 1)], g.current);
    I !== -1 ? ($(I), E.current = I) : l.key !== " " && (g.current = "", K(!1));
  }), te = f.useMemo(() => ({
    onKeyDown: v
  }), [v]), j = f.useMemo(() => ({
    onKeyDown: v,
    onKeyUp(l) {
      l.key === " " && K(!1);
    }
  }), [v, K]);
  return f.useMemo(() => q ? {
    reference: te,
    floating: j
  } : {}, [q, te, j]);
}
function ut(o) {
  const c = o.getBoundingClientRect();
  if (process.env.NODE_ENV === "test")
    return c;
  const n = window.getComputedStyle(o, "::before"), d = window.getComputedStyle(o, "::after");
  if (!(n.content !== "none" || d.content !== "none"))
    return c;
  const k = parseFloat(n.width) || 0, i = parseFloat(n.height) || 0, F = parseFloat(d.width) || 0, q = parseFloat(d.height) || 0, M = Math.max(c.width, k, F), b = Math.max(c.height, i, q), N = M - c.width, O = b - c.height;
  return {
    left: c.left - N / 2,
    right: c.right + N / 2,
    top: c.top - O / 2,
    bottom: c.bottom + O / 2
  };
}
export {
  st as a,
  ut as g,
  ct as u
};
